export const ACCOUNTS_STORAGE_KEYS = {
  CORE: "mt6_accounts_core",
  ACTIVE_ACCOUNT: "mt6_accounts_active_account",
} as const;
